export default function YelpAPI() {
  return (
    '2grvP7Brw1ligNKMlledaZ8lPfqGJtt3PAGutes_-zBcowQKXtQH3MZOSVF71dg9D8GuiRlV8o8FONw3lvCq12xhpGLUeWT1KKhg2ctiUd5CQKkeo5sijOV-M0v0W3Yx'
  );
}



// WEBPACK FOOTER //
// ./src/yelp.js